(function () {
  'use strict';

  // Mobile menu toggle
  var header = document.getElementById('SiteHeader');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      header.classList.toggle('nav-open');
    });
  }

  // Product gallery: swipe / drag / arrows / thumbnails
  var gmain = document.getElementById('GMain');
  if (gmain) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); }).filter(Boolean);
    var gm = gmain.closest('.gmain') || gmain;
    var cur = 0;

    function show(i) {
      if (!srcs.length) return;
      cur = (i + srcs.length) % srcs.length; // wrap around
      if (srcs[cur]) gmain.src = srcs[cur];
      thumbs.forEach(function (x, xi) { x.classList.toggle('active', xi === cur); });
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    if (srcs.length > 1) {
      // arrow buttons (desktop)
      var mkNav = function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gnav g' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = '<svg viewBox="0 0 24 24"><path d="' + (dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>';
        b.addEventListener('click', function (e) { e.stopPropagation(); show(cur + (dir === 'prev' ? -1 : 1)); });
        return b;
      };
      gm.appendChild(mkNav('prev'));
      gm.appendChild(mkNav('next'));

      // touch swipe
      var tx = null;
      gm.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx; tx = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      });

      // mouse drag (desktop)
      var mx = null;
      gm.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') mx = e.clientX; });
      gm.addEventListener('pointerup', function (e) {
        if (mx === null) return;
        var dx = e.clientX - mx; mx = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      });

      // keyboard arrows
      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(cur - 1);
        else if (e.key === 'ArrowRight') show(cur + 1);
      });
    }
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input[type=number]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(btn.getAttribute('data-qty'), 10);
      if (v < 1) v = 1;
      input.value = v;
    });
  });
})();
